import classNames from 'classnames';

import { Space } from '@sravni/react-design-system/lib/Space';

import pixelStyles from '@src/components/Pixel/styles.module.scss';
import { open } from '@src/helpers/navigationHelper';
import { useBrandingContent } from '@src/reducers/branding';
import { isServer } from '@src/utils';
import { ClientOnly } from 'shared/ui/ClientOnly/ClientOnly';

import { SponsoredMenu } from '../SponsoredMenu/SponsoredMenu';

import { CALCULATOR_SPONSOR_COMPANY_NAME } from './CalculatorSponsorBanner.config';
import styles from './CalculatorSponsorBanner.module.scss';
import { CalculatorSponsorDisclaimer } from './components/CalculatorSponsorDisclaimer';

interface Props {
  isShowDisplayPixel: boolean;
  isShowTrackingPixel: boolean;
  bannerVariant?: 'default' | 'entryPoint';
}

export function CalculatorSponsorBanner({ isShowDisplayPixel, isShowTrackingPixel, bannerVariant = 'default' }: Props) {
  const branding = useBrandingContent();

  const title = branding?.sponsor?.popover?.title || CALCULATOR_SPONSOR_COMPANY_NAME;
  const isEntryPoint = bannerVariant === 'entryPoint';
  const clickPixelLink = branding?.analytics?.click;

  const handleClick = () => {
    open({ href: clickPixelLink, features: 'noopener', target: '_blank' });
  };

  return (
    <>
      <div
        className={classNames(styles.advertising, 'desktop:hidden', { [styles.entryPointAdvertising]: isEntryPoint })}
      >
        <SponsoredMenu company={title} />
      </div>
      <div className={classNames(styles.container, { [styles.entryPointContainer]: isEntryPoint })}>
        <div onClick={clickPixelLink ? handleClick : undefined}>
          <Space className={classNames(styles.logoContainer, { [styles.entryPointLogoContainer]: isEntryPoint })}>
            <img alt="Лого" {...branding.logo} className={styles.logo} />
          </Space>
          <Space
            direction="column"
            align="center"
            className={classNames({ [styles.entryPointImageContainer]: isEntryPoint })}
          >
            <img alt="Лого" {...branding.image} className={classNames({ [styles.entryPointImage]: isEntryPoint })} />
          </Space>
          {!isEntryPoint && <CalculatorSponsorDisclaimer heading={branding?.sponsor?.title} />}
        </div>
        <ClientOnly>
          {!isServer && isShowDisplayPixel && branding?.analytics?.display && (
            <img alt="" className={pixelStyles.pixel} src={branding?.analytics?.display} />
          )}
          {!isServer && isShowTrackingPixel && branding?.analytics?.tracking && (
            <img alt="" className={pixelStyles.pixel} src={branding?.analytics?.tracking} />
          )}
        </ClientOnly>

        <div className={classNames(styles.advertising, 'mobile:hidden')}>
          <SponsoredMenu company={title} />
        </div>
      </div>
    </>
  );
}

CalculatorSponsorBanner.displayName = '';
